import React from 'react';
import trust from './assets/mineko-trust-header.png';
import Trust from './Trust';

const TrustIcon: React.FC = () => {
  return <Trust width={60} height={48} asset={trust} alt="Bewertet als SEHR GUT" />;
};

export default TrustIcon;
